export default (theme: Object) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.main,
  },
});
